export default __webpack_public_path__ + "yen-symbol.png";